import React, { useState, useEffect, useCallback } from 'react';
import { svgSprite } from '../../../../../hybrid/wrappers';
import PropTypes from 'prop-types';
import css from './ModalDropDown.module.scss';
import classnames from 'classnames';

const ModalDropDown = ({ showDropdown, modal, dataArr, children, ContactImg, refTable, modalDropdown, refTableChild }) => {
    const [display, setDisplay] = useState({});

    const func = useCallback(() => {
        if (modal?.current) {
            const dropDownHeight = modalDropdown?.current?.getBoundingClientRect()?.height;
            const top =
                modalDropdown?.current?.getBoundingClientRect()?.top -
                refTable?.current.getBoundingClientRect()?.top +
                dropDownHeight;
            const left = modalDropdown?.current?.getBoundingClientRect()?.left - refTable?.current.getBoundingClientRect()?.left;
            const limitBottom = refTable?.current.getBoundingClientRect()?.height;

            if (top > limitBottom || top < 0) {
                setDisplay({ display: 'none' });
            } else {
                setDisplay({ display: 'flex' });
            }

            modal.current.style.top = `${top}px`;
            modal.current.style.left = `${left}px`;
        }
    }, [modal, modalDropdown, refTable]);

    useEffect(() => {
        const refTableChildElement = refTableChild?.current;
        if (refTableChildElement) {
            refTableChildElement.addEventListener('scroll', func);
        }

        return () => {
            refTableChildElement.removeEventListener('scroll', func);
        };
    }, [refTableChild, func]);

    return (
        <div
            ref={modal}
            style={showDropdown ? display : { display: 'none' }}
            className={classnames(css.dropdownBlockColumn, showDropdown && css.dropdownBlockColumnActiveWeb)}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            {dataArr.map((item, idx) => {
                if (children[item] !== null) {
                    return (
                        <p className={css.dropdownItem} key={`dditem${idx}`}>
                            {svgSprite(ContactImg(item), {
                                fill: 'var(--greenDeepColor)',
                                className: css.contactIcon
                            })}
                            {`${children[item]}`}
                        </p>
                    );
                }
            })}
        </div>
    );
};

ModalDropDown.propTypes = {
    showDropdown: PropTypes.bool,
    modal: PropTypes.object,
    dataArr: PropTypes.array,
    ContactImg: PropTypes.func,
    refTable: PropTypes.object,
    modalDropdown: PropTypes.object,
    refTableChild: PropTypes.object
};
export default ModalDropDown;
